import {hmapPathParamConfig, hmapPathParamRegex} from "../../modules/hmap/hmap.routes.js";

export var JobApprovalRoutes = {
    [`/job-approvals/${hmapPathParamRegex}?brandId&jobId&flowId`]: {
        "name": "appLayout.harriSH.access-portal.job-approvals",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig,
            brandId: {
                dynamic: true,
            },
            jobId: {
                dynamic: true,
            },
            flowId: {
                dynamic: true,
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job_approval", 'centralized-settings']
        },
        "onEnter": ['$state', '$stateParams', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, navigationService, useGPSettingsNav) {
                navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav,
                    $state.href('appLayout.harriSH.access-portal.job-approvals', {
                        hmapPath: $stateParams['hmapPath']
                    }))
                    .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                        }
                    })
                    .catch(console.error);
            }],
        "component": "hmapJobApprovalsListingContainer",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/job-approval/job-approval.module.js");
                }
            }
        ]
    },
    "/job-approvals/{brandId:[0-9]+}?jobId&flowId": {
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job_approval", 'centralized-settings']
        },
        "params": {
            jobId: {
                dynamic: true,
            },
            flowId: {
                dynamic: true,
            }
        },
        "component": "jobApprovalsListingContainer",
        "type": "frontend",
        "name": "appLayout.harriSH.job-approvals",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/job-approval/job-approval.module.js");
                }
            },

        ],
        "showGlobalSearch": true,
        "loginRequired": true
    },
};
